import request from './utils/request'

class QuizService {
  static getQuizzes(page = 1) {
    return request('GET', 'quiz/quizzes/', undefined, { page })
  }

  static getQuiz(id) {
    return request('GET', `quiz/quizzes/${id}/`)
  }

  static addQuiz(data) {
    return request('POST', 'quiz/quizzes/', data)
  }

  static editQuiz(id, data) {
    return request('PUT', `quiz/quizzes/${id}/`, data)
  }

  static deleteQuiz(id) {
    return request('DELETE', `quiz/quizzes/${id}/`)
  }
}

export default QuizService
